module.exports = __webpack_public_path__ + "img/bg_行企动态.9af5f65c.png";